import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

export class FootchinkoItem extends Phaser.Sprite {

    public canBeHit: boolean;
    public canBeBurnt: boolean;
    public canBeAffectedByVoodoo: boolean;
    public hits: number;
    public burntFrameName: string;
    public rightItem: boolean;
    public itemRotation: number;
    public burnt: boolean;
    public smokeSprite: Phaser.Sprite;
    public justHit: boolean;

    constructor(game: Phaser.Game, x: number, y: number, textureAtlas: string,
                canBeBurnt?: boolean, canBeAffectedByVoodoo?: boolean,
                rotation?: number, rightItem?: boolean, hits?: number) {

        super(game, x, y, textureAtlas);

        this.itemRotation = rotation;

        if (canBeBurnt == null) {
            this.canBeBurnt = false;
        } else {
            this.canBeBurnt = canBeBurnt;
        }

        if (canBeAffectedByVoodoo === null) {
            this.canBeAffectedByVoodoo = false;
        } else {
            this.canBeAffectedByVoodoo = canBeAffectedByVoodoo;
        }

        if (this.canBeBurnt || this.canBeAffectedByVoodoo) {
            this.smokeSprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "humo_0001");
            this.smokeSprite.animations.add("burn", Phaser.Animation.generateFrameNames("humo_", 1, 5, "", 4), 8, true);
            this.smokeSprite.anchor.set(.5);
        }

        if (rotation === null) {
            this.itemRotation = 0;
        } else {
            this.itemRotation = rotation;
        }

        if (rightItem === null) {
            this.rightItem = true;
        } else {
            this.rightItem = rightItem;
        }

        if (hits == null) {
            this.hits = null;
        } else {
            this.hits = hits;
        }

        this.justHit = false;

        this.burnt = false;

        this.game.physics.p2.enable(this, GameConstants.SHOW_PHYSICS_BODIES);

        this.setBody();
        this.setView();
    }

    public setBody(): void {
        // override
    }

    public setView(): void {

        this.alpha = GameConstants.ALPHA_PHYSICS_BODIES;
    }

    public hit(): void {

        if (this.hits !== null) {
            this.hits = this.hits > 1 ? this.hits - 1 : 0;
        }
    }

    public burn(): void {

        if (!this.canBeBurnt) {
            return;
        }

        this.addChild(this.smokeSprite);
        this.smokeSprite.animations.play("burn", 12, false, true);

        this.burnt = true;

        this.body.destroy();
        this.body = null;

        this.frameName = this.burntFrameName;

        // ponerlo en el 0 del contenedor
        var pegsContainer: Phaser.Group = <Phaser.Group>this.parent;
        pegsContainer.swap(pegsContainer.getBottom(), this);

        AudioManager.getInstance().playEffect("quemar_rival");
    }

    public makeVoodoo(): void {

        this.game.time.events.add(1500 + Math.random() * 1000, function (): void {

            this.body.destroy();
            this.body = null;

            this.addChild(this.smokeSprite);
            let burnAnimation: Phaser.Animation = this.smokeSprite.animations.play("burn", 8, false, true);
            burnAnimation.onComplete.add(this.disappear, this);

            AudioManager.getInstance().playEffect("quemar_rival");

        }, this);
    }

    private disappear(): void {

        this.game.add.tween(this)
            .to({ alpha: 0 }, 750, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function (): void {
                this.visible = false;
            }, this);
    }
}
